import { Avatar, Button, Row, Col, Card, DatePicker, Select, Input, Empty } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import exportFromJSON from "export-from-json";
import Spinner from "../spinner/Spinner";
import ReportCard from "./components/ReportCard";
import moment from "moment";

import resourceSvg from "../assets/svg/resource.svg";
import { disabledDate, resourceTypes } from "../utils/CommonFunctions";
import { SearchOutlined, DownloadOutlined, UserOutlined } from "@ant-design/icons";

import { getAllWorkspaceResources } from "./duck/ResourceActions";
import BarChartReact from "./components/VerticalChart";
import PieChart from "./components/PieChart";
import trophy from "../assets/images/images_trophy.png";
import AppUrl from "../config/AppUrl";
import axios from "axios";

/* const chartConfig = {
  meta: {
    xLabel: "Tenants",
    yLabel: "Counts",
    datasetLabel: "Booking",
  },
  ranges: {
    week: {
      labels: [
        ["Unit 8 Front", "(CLOSED FROM 17/6)"],
        ["Unit 4A"],
        ["Unit 8 Rear", "(CLOSED FROM 17/6)"],
        ["Maltings", "Hub Boardroom"],
        ["Maltings", "Hub Boardroom"],
        ["Maltings", "Hub Boardroom"],
        ["Arch 9"],
      ],
      values: [65, 75, 70, 80, 90, 80, 90],
    },
    month: {
      labels: [
        ["Unit 8 Front"],
        ["Unit 4A"],
        ["Unit 8 Rear"],
        ["Maltings"],
        ["Hub Boardroom"],
        ["Arch 9"],
        ["Unit 12"],
      ],
      values: [85, 60, 68, 72, 85, 80, 60],
    },
    threeMonths: {
      labels: [
        ["Unit 8 Front"],
        ["Unit 4A"],
        ["Unit 8 Rear"],
        ["Maltings"],
        ["Hub Boardroom"],
        ["Arch 9"],
        ["Unit 12"],
      ],
      values: [10, 50, 60, 70, 78, 80, 50],
    },
  },
};

const chartConfig2 = {
  meta: {
    xLabel: "Tenants",
    yLabel: "Occupancy",
    datasetLabel: "Occupancy Data",
  },
  ranges: {
    week: {
      labels: [
        ["Unit"],
        ["Unit 4A"],
        ["Unit 8 Rear"],
        ["Maltings"],
        ["Maltings", "Hub Boardroom"],
        ["Unit 62"],
        ["Arch 9"],
      ],
      values: [29, 75, 70, 80, 90, 80, 90],
    },
    month: {
      labels: [
        ["Unit 8 Front"],
        ["Unit 4A"],
        ["Unit 8 Rear"],
        ["Maltings"],
        ["Hub Boardroom"],
        ["Arch 9"],
        ["Unit 12"],
      ],
      values: [15, 60, 68, 72, 85, 80, 60],
    },
    threeMonths: {
      labels: [
        ["Maltings"],
        ["Unit 4A"],
        ["Unit 8 Rear"],
        ["Maltings"],
        ["Hub Boardroom"],
        ["Arch 9"],
        ["Unit 12"],
      ],
      values: [99, 50, 60, 70, 78, 80, 50],
    },
  },
};
 */

const initialChartData = {
  chartConfig: {
    meta: {
      xLabel: "Tenants",
      yLabel: "Counts",
      datasetLabel: "Booking",
      minData: 0,
      maxData: 80,
      stepSize: 10,
    },
    ranges: {
      week: { labels: [], values: [] },
      month: { labels: [], values: [] },
      threeMonths: { labels: [], values: [] },
    },
  },
  chartConfig2: {
    meta: {
      xLabel: "Tenants",
      yLabel: "Occupancy",
      datasetLabel: "Occupancy Data",
      minData: 0,
      maxData: 35,
      stepSize: 5,
    },
    ranges: {
      week: { labels: [], values: [] },
      month: { labels: [], values: [] },
      threeMonths: { labels: [], values: [] },
    },
  },
};

const BOOKER_RANGE_KEYS = ["week", "month", "threeMonths"];

const BOOKER_RANGE_LABELS = {
  week: "Last Week",
  month: "Last Month",
  threeMonths: "Last 3 Months",
};

const initialBookerRanges = {
  week: { topBookers: [], searchResults: [] },
  month: { topBookers: [], searchResults: [] },
  threeMonths: { topBookers: [], searchResults: [] },
};

const initialBookerChartConfig = {
  meta: {
    xLabel: "Bookers",
    yLabel: "Bookings",
    datasetLabel: "Booking Count",
    minData: 0,
    maxData: 10,
    stepSize: 1,
  },
  ranges: {
    week: { labels: [], values: [] },
    month: { labels: [], values: [] },
    threeMonths: { labels: [], values: [] },
  },
};

const getBookerName = (booker) =>
  booker?.name ||
  booker?.full_name ||
  booker?.user_name ||
  booker?.member_name ||
  booker?.member?.name ||
  booker?.user?.name ||
  "Unknown";

const getBookerEmail = (booker) =>
  booker?.email ||
  booker?.member_email ||
  booker?.user_email ||
  booker?.member?.email ||
  booker?.user?.email ||
  "";

const getBookerCount = (booker) =>
  booker?.booking_count ||
  booker?.bookingCount ||
  booker?.total_bookings ||
  booker?.totalBookings ||
  booker?.count ||
  0;

const MeetingRooms = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({
    text: "",
    id: "6131be01752fd427b8360db6",
    searchActive: false,
  });
  const [range, setRange] = useState("week");
  const [bookerRange, setBookerRange] = useState("week");
  const [bookerSearchText, setBookerSearchText] = useState("");
  const [bookerSearch, setBookerSearch] = useState("");
  const [frequentBookers, setFrequentBookers] = useState(initialBookerRanges);
  const [bookerChartConfig, setBookerChartConfig] = useState(
    initialBookerChartConfig
  );
  const [frequentBookersLoading, setFrequentBookersLoading] = useState(false);
  const activeWorkSpace = useSelector((state) => state?.workSpace?.active);
  const resources = useSelector((state) => state.resources?.resources);
  const resourceMap = useSelector((state) => state.resources?.resourceMap);
  const meetingRooms = useMemo(
    () => resources?.[activeWorkSpace]?.meetingRooms || [],
    [resources, activeWorkSpace],
  );

  const [chartConfigData, setChartConfigData] = useState(initialChartData);

  console.log(chartConfigData, "chartConfigData");

  const meetingRoomSpin = !meetingRooms?.length && resources?.loading;

  const buildRangeData = (range) => ({
    labelTopResources:
      range?.topResources?.map((r) => output(r.resource_name)) ?? [],
    valueTopResources: range?.topResources?.map((r) => r.total_bookings) ?? [],
    labelAvgOccupancy:
      range?.avgOccupancy?.map((r) => output(r.resource_name)) ?? [],
    valueAvgOccupancy:
      range?.avgOccupancy?.map((r) => Math.round(r.occupancy_percentage)) ?? [],
  });

  function output(input, chunkSize = 2) {
    if (typeof input !== "string") return [];

    const words = input.split(" ");

    const result = [];
    for (let i = 0; i < words.length; i += chunkSize) {
      result.push(words.slice(i, i + chunkSize).join(" "));
    }

    return result;
  }

  const normalizeBookersResponse = (payload) => {
    const data = payload?.data ?? payload;

    const getRange = (rangeKey) => ({
      topBookers: Array.isArray(data?.[rangeKey]?.topBookers)
        ? data[rangeKey].topBookers
        : [],
      searchResults: Array.isArray(data?.[rangeKey]?.searchResults)
        ? data[rangeKey].searchResults
        : [],
    });

    return {
      week: getRange("week"),
      month: getRange("month"),
      threeMonths: getRange("threeMonths"),
    };
  };

  const buildBookerChartConfig = (ranges) => {
    const values = BOOKER_RANGE_KEYS.flatMap((rangeKey) =>
      ranges[rangeKey].topBookers.map((booker) => getBookerCount(booker))
    );
    const maxValue = Math.max(10, ...values);
    const maxData = Math.ceil(maxValue / 5) * 5;

    return {
      ...initialBookerChartConfig,
      meta: {
        ...initialBookerChartConfig.meta,
        maxData,
        stepSize: Math.max(1, Math.ceil(maxData / 5)),
      },
      ranges: BOOKER_RANGE_KEYS.reduce((acc, rangeKey) => {
        acc[rangeKey] = {
          labels: ranges[rangeKey].topBookers.map((booker) =>
            output(getBookerName(booker))
          ),
          values: ranges[rangeKey].topBookers.map((booker) =>
            getBookerCount(booker)
          ),
        };
        return acc;
      }, {}),
    };
  };

  const getChartData = useCallback(async () => {
    try {
      const response = await axios.get(AppUrl.REPORT_CHART);
      if (response.data?.meta?.success && response.data?.meta?.status === 200) {
        const { data } = response.data;
        const weekData = buildRangeData(data?.week);
        const monthData = buildRangeData(data?.month);
        const threeMonthsData = buildRangeData(data?.threeMonths);

        setChartConfigData((prev) => ({
          ...prev,

          chartConfig: {
            ...prev.chartConfig,
            ranges: {
              week: {
                labels: weekData.labelTopResources,
                values: weekData.valueTopResources,
              },
              month: {
                labels: monthData.labelTopResources,
                values: monthData.valueTopResources,
              },
              threeMonths: {
                labels: threeMonthsData.labelTopResources,
                values: threeMonthsData.valueTopResources,
              },
            },
          },

          chartConfig2: {
            ...prev.chartConfig2,
            ranges: {
              week: {
                labels: weekData.labelAvgOccupancy,
                values: weekData.valueAvgOccupancy,
              },
              month: {
                labels: monthData.labelAvgOccupancy,
                values: monthData.valueAvgOccupancy,
              },
              threeMonths: {
                labels: threeMonthsData.labelAvgOccupancy,
                values: threeMonthsData.valueAvgOccupancy,
              },
            },
          },
        }));
      }
    } catch (error) {
      console.error("Server error:", error.message);
    }
  }, []);

  useEffect(() => {
    getChartData();
  }, [getChartData]);

  const getFrequentBookers = useCallback(async () => {
    try {
      setFrequentBookersLoading(true);
      const response = await axios.get(AppUrl.REPORT_BOOKERS, {
        params: {
          space_id: activeWorkSpace || undefined,
          q: bookerSearch || undefined,
          limit: 10,
        },
      });

      if (response.data?.meta?.success !== false) {
        const bookerRanges = normalizeBookersResponse(response.data);
        setFrequentBookers(bookerRanges);
        setBookerChartConfig(buildBookerChartConfig(bookerRanges));
      }
    } catch (error) {
      console.error("Frequent bookers error:", error.message);
      setFrequentBookers(initialBookerRanges);
      setBookerChartConfig(initialBookerChartConfig);
    } finally {
      setFrequentBookersLoading(false);
    }
  }, [activeWorkSpace, bookerSearch]);

  useEffect(() => {
    getFrequentBookers();
  }, [getFrequentBookers]);

  const onBookerSearch = useCallback(() => {
    setBookerSearch(bookerSearchText.trim());
  }, [bookerSearchText]);

  const onBookerReset = useCallback(() => {
    setBookerSearchText("");
    setBookerSearch("");
  }, []);

  const activeSearchResults =
    frequentBookers?.[bookerRange]?.searchResults || [];

  const renderBookerCards = useCallback((bookers) => {
    if (!bookers.length) {
      return <Empty description="No bookers found" />;
    }

    return (
      <Row gutter={[12, 12]}>
        {bookers.map((booker, index) => {
          const name = getBookerName(booker);
          const email = getBookerEmail(booker);
          const count = getBookerCount(booker);
          const key =
            booker?._id ||
            booker?.id ||
            booker?.user_id ||
            booker?.member_id ||
            email ||
            index;

          return (
            <Col xs={24} key={key}>
              <div
                style={{
                  border: "1px solid #f0f0f0",
                  borderRadius: 4,
                  padding: 14,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  minHeight: 78,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    minWidth: 0,
                  }}
                >
                  <Avatar
                    icon={<UserOutlined />}
                    style={{
                      marginRight: 12,
                      backgroundColor: "#7367f0",
                      flex: "0 0 auto",
                    }}
                  />
                  <div style={{ minWidth: 0 }}>
                    <div
                      style={{
                        fontWeight: 600,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                      title={name}
                    >
                      {name}
                    </div>
                    <small
                      style={{
                        color: "#6e6b7b",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "block",
                      }}
                      title={email}
                    >
                      {email || "-"}
                    </small>
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "right",
                    marginLeft: 12,
                    flex: "0 0 auto",
                  }}
                >
                  <div style={{ fontSize: 18, fontWeight: 600 }}>{count}</div>
                  <small style={{ color: "#6e6b7b" }}>bookings</small>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    );
  }, []);

  const handleChange = useCallback(
    (name) => (event) => {
      let value = event?.target?.value ?? event;

      setFilter((pre) => ({
        ...pre,
        [name]: value,
      }));
    },
    [],
  );

  const onSearch = () => {
    let payload = {
      id: filter.id,
    };
    if (filter.from) {
      payload.from = filter.from;
    }
    if (filter.to) {
      payload.to = filter.to;
    }

    setFilter((pre) => ({
      ...pre,
      searchActive: true,
    }));
    dispatch(getAllWorkspaceResources(payload));
  };
  const onReset = () => {
    setFilter({
      text: "",
      id: "6131be01752fd427b8360db6",
      searchActive: false,
    });
    dispatch(getAllWorkspaceResources(filter?.id));
  };

  const filteredMeeting = meetingRooms.filter((meeting) =>
    resourceMap[meeting]?.name
      ?.toLowerCase()
      .includes(filter?.text?.toLowerCase()),
  );

  const onExcelDownload = () => {
    const data = filteredMeeting.map((id, index) => {
      const meetingObject = resourceMap[id] || {};
      return {
        "S.no": index + 1,
        Name: meetingObject.name,
        Description: meetingObject.description || "",
        Capacity: meetingObject.capacity,
        "Start Date": filter.from
          ? moment(filter.from).format("DD-MM-YYYY")
          : "",
        "End Date": filter.to
          ? moment(filter.to).format("DD-MM-YYYY")
          : moment().format("DD-MM-YYYY"),
        "Total Booking": meetingObject?.booking_data?.total_bookings || 0,
        "Rebooking Count":
          meetingObject?.booking_data?.rebooking_user_count || 0,
        Price: meetingObject?.price,
      };
    });
    const fileName = "Meeting Report";
    const exportType = exportFromJSON.types.xls;
    exportFromJSON({ data, fileName, exportType });
  };

  return meetingRoomSpin ? (
    <Spinner />
  ) : (
    <div>
      <div className="container_btn">
        <button
          className={`${range === "week" ? "active_btn" : ""}`}
          onClick={() => setRange("week")}
        >
          Last Week
        </button>
        <button
          className={`${range === "month" ? "active_btn" : ""}`}
          onClick={() => setRange("month")}
        >
          Last Month
        </button>
        <button
          className={`${range === "threeMonths" ? "active_btn" : ""}`}
          onClick={() => setRange("threeMonths")}
        >
          Last 3 Months
        </button>
      </div>
      <Row className="container_graph_outer_cb">
        {/* Buttons */}
        <Col className="container_graph" span={12}>
          <div className="container_graph_inner f_graph">
            <div className="title_cb">Popular Meeting Rooms</div>
            <BarChartReact
              range={range}
              chartConfig={chartConfigData?.chartConfig || {}}
            />
          </div>
        </Col>

        <Col className="container_graph" span={12}>
          <div className="container_graph_inner f_graph">
            <div className="title_cb">
              Average Occupancy{" "}
              <span className="short_title">
                (With Reference To Meeting Rooms)
              </span>
            </div>
            <BarChartReact
              range={range}
              chartConfig={chartConfigData?.chartConfig2 || {}}
            />
          </div>
        </Col>

        {/* <Col className="container_graph" span={6}>
          <div className="container_graph_inner f_graph">
            <div className="title_cb">Most Popular</div>
            <div>
              <div className="container_img">
                <img src={trophy} alt="" />
                <ul className="container_list">
                  <li>Unit 8 Front (CLOSED FROM 17/6)</li>
                  <li>OLD Unit 62-63</li>
                  <li>Maltings Hub Small Meeting Room</li>
                </ul>
              </div>
            </div>
          </div>
        </Col> */}
      </Row>

      <Row className="container_graph_outer_cb">
        <Col className="container_graph" xs={24} lg={14}>
          <div className="container_graph_inner f_graph">
            <div
              className="title_cb"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 12,
              }}
            >
              <span>Most Frequent Bookers</span>
              <div
                className="container_btn"
                style={{
                  marginBottom: 0,
                  flexWrap: "wrap",
                }}
              >
                <button
                  className={`${bookerRange === "week" ? "active_btn" : ""}`}
                  onClick={() => setBookerRange("week")}
                >
                  Last Week
                </button>
                <button
                  className={`${bookerRange === "month" ? "active_btn" : ""}`}
                  onClick={() => setBookerRange("month")}
                >
                  Last Month
                </button>
                <button
                  className={`${
                    bookerRange === "threeMonths" ? "active_btn" : ""
                  }`}
                  onClick={() => setBookerRange("threeMonths")}
                >
                  Last 3 Months
                </button>
              </div>
            </div>
            {frequentBookersLoading ? (
              <div style={{ padding: "15px 0" }}>Loading bookers...</div>
            ) : (
              <BarChartReact
                range={bookerRange}
                chartConfig={bookerChartConfig}
              />
            )}
          </div>
        </Col>

        <Col className="container_graph" xs={24} lg={10}>
          <div className="container_graph_inner f_graph">
            <div className="title_cb">Search Bookers</div>
            <Row align="middle" className="mb15" gutter={[8, 8]}>
              <Col span={24}>
                <Input
                  size="large"
                  className="custom-input"
                  style={{ width: "100%", fontWeight: "500" }}
                  placeholder="Search by name or email"
                  prefix={<SearchOutlined />}
                  value={bookerSearchText}
                  onChange={(event) => setBookerSearchText(event.target.value)}
                  onPressEnter={onBookerSearch}
                  allowClear
                />
              </Col>
              <Col>
                <Button
                  className="nw_btn_black"
                  size="large"
                  type="primary"
                  onClick={onBookerSearch}
                >
                  Search
                </Button>
              </Col>
              <Col>
                <Button
                  className="nw_btn_white"
                  size="large"
                  type="primary-outline"
                  onClick={onBookerReset}
                >
                  Reset
                </Button>
              </Col>
            </Row>

            {bookerSearch && (
              <div>
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    marginBottom: 12,
                  }}
                >
                  Search Results - {BOOKER_RANGE_LABELS[bookerRange]}
                </div>
                {renderBookerCards(activeSearchResults)}
              </div>
            )}
          </div>
        </Col>
      </Row>

      <Card
        title="Filter"
        className="nw_filter_container"
        size="small"
        bordered={false}
      >
        <Input
          size="large"
          className="custom-input mr10"
          style={{ width: "25%", fontWeight: "500", marginRight: "15px" }}
          placeholder="Search Meeting Room Name"
          prefix={<SearchOutlined />}
          value={filter?.text}
          onChange={handleChange("text")}
          allowClear
        />
        <DatePicker
          style={{
            width: "17%",
            fontWeight: "500",
            marginRight: "15px",
          }}
          className="nw_mobile_container"
          onChange={handleChange("from")}
          placeholder="From"
          value={filter?.from}
          disabledDate={disabledDate({ isFutureDateDisabled: true })}
          allowClear
          size="large"
          inputReadOnly={true}
        />
        <DatePicker
          style={{
            width: "17%",
            fontWeight: "500",
            marginRight: "15px",
          }}
          onChange={handleChange("to")}
          placeholder="To"
          value={filter?.to}
          disabledDate={disabledDate({ isFutureDateDisabled: true })}
          allowClear
          size="large"
          className="nw_mobile_container"
          inputReadOnly={true}
        />

        <Button
          className="mr10 nw_btn_black"
          size="large"
          type="primary"
          onClick={onSearch}
        >
          Search
        </Button>
        <Button
          className="mr10 nw_btn_white"
          size="large"
          type="primary-outline"
          onClick={onReset}
        >
          Reset
        </Button>
        <Button
          className="mr10 nw_btn_white"
          size="large"
          type="primary-outline"
          onClick={onExcelDownload}
          icon={<DownloadOutlined />}
        >
          Download in Excel
        </Button>
      </Card>
      <div className="resourceMain">
        {filteredMeeting?.length === 0 && (
          <Row justify="center" align="middle" className="mt20 pt20">
            <img src={resourceSvg} alt="No resource added!" />
          </Row>
        )}

        <Row style={{ display: "flex" }}>
          {filteredMeeting?.map?.((id) => (
            <Col span={12} style={{ padding: "10px" }}>
              <ReportCard
                key={id}
                id={id}
                type={"meeting_room"}
                filter={filter}
                onReset={onReset}
                // onEdit={handleModal}
              />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default MeetingRooms;
